import { LocalStorageKeys } from '@/types';
var authSessionKeys = [
    LocalStorageKeys.JWT,
    LocalStorageKeys.RefreshToken,
    LocalStorageKeys.Departments,
    LocalStorageKeys.UserType,
    LocalStorageKeys.CompanyId
];
var getStorageForUserType = function (userType) {
    return userType === 'BranuUser' ? sessionStorage : localStorage;
};
var hasBranuSession = function () {
    return !!sessionStorage.getItem(LocalStorageKeys.JWT);
};
var getActiveStorage = function () {
    return hasBranuSession() ? sessionStorage : localStorage;
};
export var getAuthItem = function (key, userType) {
    return (userType ? getStorageForUserType(userType) : getActiveStorage()).getItem(key);
};
// ユーザー種別を指定しない更新は現在の認証セッションの保存先へ書き戻す
export var setAuthItem = function (key, value, userType) {
    var storage = userType ? getStorageForUserType(userType) : getActiveStorage();
    storage.setItem(key, value);
};
export var removeAuthItem = function (key, userType) {
    if (userType) {
        getStorageForUserType(userType).removeItem(key);
        return;
    }
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
};
export var clearAuthSession = function () {
    authSessionKeys.forEach(function (key) { return removeAuthItem(key); });
    // 両方の認証情報を削除し、通常ユーザーのdevice_uuidはlocalStorageで共有するため残す
    removeAuthItem(LocalStorageKeys.DeviceUUID, 'BranuUser');
};
export var saveAuthSession = function (session) {
    // ログイン切替時は両方の認証情報を削除してから対象ユーザーの保存先へ書き込む
    clearAuthSession();
    setAuthItem(LocalStorageKeys.JWT, session.jwt, session.userType);
    setAuthItem(LocalStorageKeys.RefreshToken, session.refreshToken, session.userType);
    setAuthItem(LocalStorageKeys.DeviceUUID, session.deviceUUID, session.userType);
    setAuthItem(LocalStorageKeys.Departments, JSON.stringify(session.departments), session.userType);
    // fetchMe前の初期処理でもユーザー種別を判定できるよう同期的に保存する
    setAuthItem(LocalStorageKeys.UserType, session.userType, session.userType);
    if (session.companyId) {
        setAuthItem(LocalStorageKeys.CompanyId, session.companyId, session.userType);
    }
    // BranuUserのlastUrlは代理ログイン前の会社へ戻さない
    removeAuthItem(LocalStorageKeys.LastURL, 'BranuUser');
};
